export default __webpack_public_path__ + "static/media/knot.91f616f9.png";